const BASE_URL = process.env.REACT_APP_URL_API;
const fetchDashboardStatisque = async ({ queryKey }) => {
  const lang = queryKey[1];
  if (!lang) return [];
  const apiRest = await fetch(`${BASE_URL}/dashboard?lang=${lang}`);
  return apiRest.json();
};

export { fetchDashboardStatisque };
